interface BackArrowIconProps {
  size?: number | string
  color?: string
  strokeWidth?: number
}

export const BackArrowIcon = ({
  color = '#242424',
  size = 24,
  strokeWidth = 2,
}: BackArrowIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <path
      d="M19 12H5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19 5 12 12 5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
